import b from 'b_';
import { BackgroundImage, H3, Text } from 'platform-components';
import {
    TEXT_MARKUP_TYPE,
    UI_KIT_HEADER_TYPOGRAPHY,
    UI_KIT_TEXT_TYPOGRAPHY,
} from 'platform-components/src/components/constants';
import React from 'react';

import { ContentShowcaseIllustration } from 'common.components/widgets.content-showcase/__illustration/content-showcase__illustration';
import { ItemContentProps } from 'common.components/widgets.content-showcase/content-showcase-widget';
import { ContentShowcaseWidgetItemData } from 'common.components/widgets.content-showcase/typings';

import './content-showcase-widget__mobile-item.scss';

interface Props {
    data: ContentShowcaseWidgetItemData;
    ItemContent: (props: ItemContentProps) => JSX.Element;
}

export const ContentShowcaseMobileItem = (props: Props) => {
    const { data, ItemContent } = props;
    const { name, description, originalData, visualSettings } = data;

    const imageSrc = visualSettings?.image;
    const colors = visualSettings?.colors;
    const backgroundColor = visualSettings?.backgroundColor;

    const renderDesc = () => {
        return (
            <div className="content-showcase-widget__mobile-item-desc">
                <div className="content-showcase-widget__mobile-item-title">
                    <H3 type={TEXT_MARKUP_TYPE.MARKDOWN} typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMBold}>
                        {name}
                    </H3>
                </div>
                <div className="content-showcase-widget__mobile-item-description">
                    <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}>{description}</Text>
                </div>
            </div>
        );
    };

    const bgColors = colors || [];

    const headerStyle = {
        backgroundImage:
            bgColors[0] && bgColors[1] ? `linear-gradient(90deg, ${bgColors[0]} 0%, ${bgColors[1]} 100%)` : undefined,
        backgroundColor,
    };

    return (
        <div className={b('content-showcase-widget', 'mobile-item')}>
            <div
                className={b('content-showcase-widget', 'mobile-item-header', { illustrated: Boolean(imageSrc) })}
                style={headerStyle}
            >
                <BackgroundImage mix="content-showcase-widget__mobile-item-bg-image" objectFit="cover" src={imageSrc} />
                {imageSrc && <ContentShowcaseIllustration imageSrc={imageSrc} />}
                {renderDesc()}
            </div>
            {imageSrc && renderDesc()}
            <div className={b('content-showcase-widget', 'mobile-item-block')}>
                <ItemContent block={originalData} />
            </div>
        </div>
    );
};
